/**
 * lib/readSheet.ts
 * ------------------------------------------------------------------
 * Read the first sheet of an Excel file (.xls or .xlsx) — or a CSV —
 * into rows of cell values, for the pure parsers in lib/ to work on.
 *
 * Both weekly uploads arrive as Excel: the clocking terminals write
 * old-style .xls, Pastel writes .xlsx. SheetJS reads both, and is
 * loaded on demand so it never weighs on the main bundle. It is
 * installed from cdn.sheetjs.com, not the npm registry, whose copy is
 * years stale and carries a published vulnerability.
 * ------------------------------------------------------------------ */
export async function readFirstSheet(file: File): Promise<unknown[][]> {
  const XLSX = await import('xlsx');
  const wb = XLSX.read(await file.arrayBuffer(), { type: 'array' });
  const name = wb.SheetNames[0];
  if (!name) throw new Error(`${file.name} has no sheets.`);
  return XLSX.utils.sheet_to_json<unknown[]>(wb.Sheets[name], { header: 1, raw: true, defval: '' });
}
